module.exports = __webpack_public_path__ + "img/history.41abf1fa.svg";